import Nullstack from 'nullstack';
export default function IconGitCompare({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-git-compare",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "6",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M11 6h5a2 2 0 0 1 2 2v8"
  }), "   ", Nullstack.element("polyline", {
    points: "14 9 11 6 14 3"
  }), "   ", Nullstack.element("path", {
    d: "M13 18h-5a2 2 0 0 1 -2 -2v-8"
  }), "   ", Nullstack.element("polyline", {
    points: "10 15 13 18 10 21"
  }), " ");
}